var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "function-parameter" },
    [
      _c(
        "div",
        { staticClass: "field" },
        [
          _c("label", [_vm._v(_vm._s(_vm.$t("message.type")))]),
          _vm._v(" "),
          _c(
            "a-select",
            {
              staticStyle: { width: "100%" },
              model: {
                value: _vm.clone.type,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "type", $$v)
                },
                expression: "clone.type",
              },
            },
            [
              _c("a-select-option", { attrs: { value: "string" } }, [
                _vm._v(_vm._s(_vm.$t("chatbotv2.paramTypeString"))),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "number" } }, [
                _vm._v(_vm._s(_vm.$t("chatbotv2.paramTypeNumber"))),
              ]),
              _vm._v(" "),
              _c("a-select-option", { attrs: { value: "boolean" } }, [
                _vm._v(_vm._s(_vm.$t("chatbotv2.paramTypeBoolean"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "field" }, [
        _c("label", [_vm._v(_vm._s(_vm.$t("message.name")))]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.clone.name,
              expression: "clone.name",
            },
          ],
          domProps: { value: _vm.clone.name },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.clone, "name", $event.target.value)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "field description" }, [
        _c("label", [_vm._v(_vm._s(_vm.$t("message.description")))]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.clone.description,
              expression: "clone.description",
            },
          ],
          domProps: { value: _vm.clone.description },
          on: {
            input: function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.clone, "description", $event.target.value)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "field" },
        [
          _c("label", [_vm._v(_vm._s(_vm.$t("message.required")))]),
          _vm._v(" "),
          _c("a-switch", {
            model: {
              value: _vm.clone.required,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "required", $$v)
              },
              expression: "clone.required",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "SupsisButton",
        {
          attrs: { danger: "" },
          on: {
            click: function ($event) {
              return _vm.$emit("delete")
            },
          },
        },
        [_c("i", { staticClass: "material-icons" }, [_vm._v("delete")])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }